import { Experiments } from "../../../domain/repositories/ABTestClient";

type ExperimentRegularNames = keyof Experiments;

type ExperimentNameDictionary = Record<ExperimentRegularNames, string>;

const shortenedExperimentNames: ExperimentNameDictionary = {
  showPSTip: "s7p",
  showBenefits: "s10s",
  returnsInfoInCheckout: "r19t",
  moreProductsPerCategory: "m21y",
  showDeliveryAndReturnProductPage: "s30e",
  buyNowGetLooks: "b14s",
};

const experimentNameShortener = (experiments: Experiments) => {
  const shortenedExperimentDictionary = Object.entries(experiments).reduce<Record<string, 0 | 1>>(
    (acc, currentEntry: [string, boolean | undefined]) => {
      const [key, value] = currentEntry;

      const shortenedName = shortenedExperimentNames[key as ExperimentRegularNames];

      const normalizedValue = value ? 1 : 0;

      return { ...acc, [shortenedName]: normalizedValue };
    },
    {},
  );

  return shortenedExperimentDictionary;
};

export { experimentNameShortener, shortenedExperimentNames };
